import type { ISpaceAuthLookupResponse } from "@/api/space/dtos/authenticator.dto";
import type { User } from "@auth/user";
import { isSignedInteger, normalizeStr } from "@/utils/utils";
import { inferIsSpaceUser } from "../../../../utils/utilitariosJwt";
import type { IntencaoBuscaUsuario } from "../loginGrupoFixo.types";
import { MIN_CARACTERES_LOOKUP_USUARIO } from "@/configs/system";

export function deveContinuarEntradaAposSelecionarUsuario(
	intencao: IntencaoBuscaUsuario,
	possuiFluxoOtpDireto: boolean,
): boolean {
	return intencao === "entrar" && possuiFluxoOtpDireto;
}

export function deveIgnorarDoisFatoresParaUsuarioSpace(
	usuario: ISpaceAuthLookupResponse | null,
	permitirBypassSpace: boolean,
): boolean {
	if (!usuario?.autenticacao_dois_fatores || !permitirBypassSpace) return false;

	return inferIsSpaceUser({
		username: usuario.nome,
	});
}

export function deveUsarFluxoOtpDireto(
	usuario: ISpaceAuthLookupResponse | null,
	permitirBypassSpace: boolean,
): boolean {
	return (
		Boolean(usuario?.autenticacao_dois_fatores) &&
		!deveIgnorarDoisFatoresParaUsuarioSpace(usuario, permitirBypassSpace)
	);
}

export function deveIgnorarDoisFatoresParaUsuarioAutenticado(
	usuario: User | null | undefined,
	permitirBypassSpace: boolean,
): boolean {
	if (!usuario?.autenticacao_dois_fatores || !permitirBypassSpace) return false;
	if (usuario.eh_usuario_space) return true;

	return inferIsSpaceUser({
		username: usuario.nome_usuario ?? usuario.nome,
	});
}

export function deveHabilitarBuscaPorNome(
	username: string,
	usuarioSelecionado: ISpaceAuthLookupResponse | null,
): boolean {
	const texto = (username ?? "").trim();

	if (texto.length < MIN_CARACTERES_LOOKUP_USUARIO) return false;
	if (isSignedInteger(texto)) return false;
	if (usuarioSelecionado && normalizeStr(usuarioSelecionado.nome) === normalizeStr(texto)) return false;

	return true;
}

export function deveHabilitarBuscaPorId(
	username: string,
	usuarioSelecionado: ISpaceAuthLookupResponse | null,
): boolean {
	const texto = (username ?? "").trim();

	if (texto.length < MIN_CARACTERES_LOOKUP_USUARIO) return false;
	if (!isSignedInteger(texto)) return false;
	if (usuarioSelecionado && String(usuarioSelecionado.id_cad_pessoa) === texto) return false;

	return true;
}

export function deveEscolherEntreMultiplos(
	username: string,
	opcoes: ISpaceAuthLookupResponse[],
	usuarioSelecionado: ISpaceAuthLookupResponse | null,
): boolean {
	const usernameTexto = (username ?? "").trim();
	const usernameTemTamanhoMinimo = usernameTexto.length >= MIN_CARACTERES_LOOKUP_USUARIO;
	const haMultiplasOpcoes = opcoes.length > 1;
	const temUsuarioSelecionado = !!usuarioSelecionado;

	return usernameTemTamanhoMinimo && haMultiplasOpcoes && !temUsuarioSelecionado;
}
